import Header from "../Components/Header/Header";
// import RecommendedSkills from "../Components/Skills/RecommendedSkills";
import Liked from "../Components/Skills/Liked";
import FavActivity from "../Media/FavActivity.svg"
import FilterSkills from "../Components/Skills/FilterSkills";
import Footer from "../Components/Footer/Footer";

const FavoriteActivities = () =>{
    return(
        <div className="activities fav-activities">
            <div className="container">
                <Header title ="Favourite Activities" />
                <div className="content-wrap bg-gradient-light">
                    <div className="activity-img mb---30">       
                        <div className="description">
                            <h2 className="title mt---0 mb---20">Favorite Activities</h2>
                            <h4 className="sub-title mt---0 mb---10">Lets take a few breaths and revisit some skills that have worked for you in the past</h4>
                            {/* <p className="text">These quick tools help calm intense emotions to find your footing before reacting.</p> */}
                        </div>
                        <Liked type="ToolBox" headTitle="My tool box"/>
                    </div>
                </div>
                <Footer /> 
            </div>
        </div>
    );
}
export default FavoriteActivities;